import { useState, useEffect } from 'react';
import { useScript } from 'hooks/head';
import { Platform } from 'app-types';

export const usePlatformLibrary = (
  platform: Platform,
): [boolean, boolean] => {
  const [postInitComplete, setPostInitComplete] = useState(false);
  const [postInitError, setPostInitError] = useState(false);
  const [initStarted, setInitStarted] = useState(false);

  useEffect(() => {
    let postInitPromise = Promise.resolve();

    if (platform === 'lg-webos') {
      /* eslint-disable import/extensions */
      // @ts-ignore
      postInitPromise = import('support/webOSTV.js');
      /* eslint-enable import/extensions */
    } else if (platform === 'vizio') {
      postInitPromise = new Promise(res => {
        document.addEventListener('VIZIO_LIBRARY_DID_LOAD', () => {
          res();
        });
      });
    }

    setInitStarted(true);
    postInitPromise
      .then(() => {
        setPostInitComplete(true);
      })
      .catch(() => {
        setPostInitComplete(true);
        setPostInitError(true);
      });
  }, [platform]);

  let platformUrl;
  let noPlatformLib = false;
  if (platform === 'vizio') {
    platformUrl = 'http://localhost:12345/scfs/cl/js/vizio-companion-lib.js';
  } else if (platform === 'samsung-tizen') {
    platformUrl = '$WEBAPIS/webapis/webapis.js';
  } else {
    // By removing setLoaded becoming true if no src is provided to useScript,
    // the app will not get past the SplashWrapper if there is no platform library for the device.
    noPlatformLib = true;
  }

  const scriptUrl = initStarted ? platformUrl : null;
  const [scriptLoaded, scriptError] = useScript(scriptUrl);

  return [
    (scriptLoaded || noPlatformLib) && postInitComplete,
    scriptError || postInitError,
  ];
};
